import React from 'react';
import { Platform, StyleSheet, type ViewProps } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';
import { theme } from '@sg/garnish';

export const BagContentContainer = (props: ViewProps) => {
  return (
    <SafeAreaView edges={SAFE_AREA_EDGES} style={styles.bagContentContainer}>
      {props.children}
    </SafeAreaView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  bagContentContainer: {
    flex: 1,
    paddingHorizontal: theme.spacing['4'],
  },
});
